/**
 * src/components/MutationQueueInstaller.tsx
 *
 * Mount-once component that wires the MutationQueue at app boot:
 *   1. Registers each mutation type's executor (mutationExecutors.ts).
 *   2. Drains anything that was persisted from a previous session.
 *   3. Re-drains whenever the browser fires `online` (the queue's exponential
 *      backoff would eventually retry, but firing immediately on reconnect
 *      keeps things snappy on a brief LTE drop).
 *
 * Renders nothing.
 */

import { useEffect } from 'react';
import { drainMutationQueue } from '../api/mutationQueue';
import { installMutationExecutors } from '../api/mutationExecutors';

export function MutationQueueInstaller() {
  useEffect(() => {
    installMutationExecutors();
    drainMutationQueue();

    const onOnline = () => drainMutationQueue();
    window.addEventListener('online', onOnline);
    return () => window.removeEventListener('online', onOnline);
  }, []);

  return null;
}
